<template>
    <v-card :loading="loading" mx-4>
        <v-skeleton-loader
            v-if="loading"
            type="card"
        ></v-skeleton-loader>
        <v-tabs
            v-else
            v-model="tab"
            background-color="primary"
            dark
        >
            <v-tab key="general">
                Informatii generale
            </v-tab>
            <v-tab key="contracts">
                Contracte
            </v-tab>
            <v-tab key="payments">
                Incasari
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="general">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.id_pin"
                                v-validate="'required'"
                                :error-messages="errorMessages('id_pin')"
                                :class="{ 'error--text': hasErrors('id_pin') }"
                                class="primary--text"
                                name="id_pin"
                                label="CNP"
                                data-vv-as="CNP"
                                data-vv-name="id_pin"
                                counter="13"
                            />
                        </v-col>
                        <v-col v-if="_.isNil(form.id) && foundCustomers !== undefined" cols="4">
                            <v-alert
                                dense
                                text
                                :type="foundCustomers === 0 ? 'success' : (foundCustomers > 0 ? 'error' : 'info')"
                            >
                                <template v-if="foundCustomers === 0">
                                    Nu am identificat nici un cursant cu CNP-ul introdus.
                                </template>
                                <template v-else-if="foundCustomers > 0">
                                    CNP-ul introdus exista deja in baza de date.
                                </template>
                                <template v-else>
                                    Verificam baza de date...
                                </template>
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.name"
                                v-validate="'required'"
                                :error-messages="errorMessages('name')"
                                :class="{ 'error--text': hasErrors('name') }"
                                class="primary--text"
                                name="name"
                                label="Nume"
                                data-vv-as="Nume"
                                data-vv-name="name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.surname"
                                v-validate="'required'"
                                :error-messages="errorMessages('surname')"
                                :class="{ 'error--text': hasErrors('surname') }"
                                class="primary--text"
                                name="surname"
                                label="Prenume"
                                data-vv-as="Prenume"
                                data-vv-name="surname"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.maiden_name"
                                :error-messages="errorMessages('maiden_name')"
                                :class="{ 'error--text': hasErrors('maiden_name') }"
                                class="primary--text"
                                name="maiden_name"
                                label="Nume anterior"
                                data-vv-as="Nume anterior"
                                data-vv-name="maiden_name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                :items="['M', 'F']"
                                v-model="form.data.sex"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.sex')"
                                :class="{ 'error--text': hasErrors('data.sex') }"
                                class="primary--text"
                                name="data.sex"
                                label="Sex"
                                data-vv-as="Sex"
                                data-vv-name="data.sex"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.phone"
                                :error-messages="errorMessages('phone')"
                                :class="{ 'error--text': hasErrors('phone') }"
                                class="primary--text"
                                name="phone"
                                label="Numar telefon"
                                data-vv-as="Numar telefon"
                                data-vv-name="phone"
                                counter="10"
                                type="number"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.data.email"
                                :error-messages="errorMessages('data.email')"
                                :class="{ 'error--text': hasErrors('data.email') }"
                                class="primary--text"
                                name="email"
                                label="Adresa email"
                                data-vv-as="Adresa email"
                                data-vv-name="email"
                                type="email"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-autocomplete
                                v-model="form.county_id"
                                v-validate="'required'"
                                :items="Static.counties"
                                :error-messages="errorMessages('county_id')"
                                :class="{ 'error--text': hasErrors('county_id') }"
                                class="primary--text"
                                name="county_id"
                                label="Judet"
                                data-vv-as="Judet"
                                item-value="id"
                                item-text="name"
                                data-vv-name="county_id"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.city"
                                v-validate="'required'"
                                :error-messages="errorMessages('city')"
                                :class="{ 'error--text': hasErrors('city') }"
                                class="primary--text"
                                name="city"
                                label="Localitate"
                                data-vv-as="Localitate"
                                data-vv-name="city"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.address"
                                v-validate="'required'"
                                :error-messages="errorMessages('address')"
                                :class="{ 'error--text': hasErrors('address') }"
                                class="primary--text"
                                name="address"
                                label="Adresa"
                                data-vv-as="Adresa"
                                data-vv-name="address"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                v-model="form.data.address_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.address_no')"
                                :class="{ 'error--text': hasErrors('data.address_no') }"
                                class="primary--text"
                                label="Nr"
                                data-vv-as="Nr"
                                data-vv-name="data.address_no"
                                name="data.address_no"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                v-model="form.data.address_bl"
                                :error-messages="errorMessages('data.address_bl')"
                                :class="{ 'error--text': hasErrors('data.address_bl') }"
                                class="primary--text"
                                label="Bl"
                                data-vv-as="Bl"
                                data-vv-name="data.address_bl"
                                name="data.address_bl"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                v-model="form.data.address_sc"
                                :error-messages="errorMessages('data.address_sc')"
                                :class="{ 'error--text': hasErrors('data.address_sc') }"
                                class="primary--text"
                                label="Sc"
                                data-vv-as="Sc"
                                data-vv-name="data.address_sc"
                                name="data.address_sc"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                v-model="form.data.address_et"
                                :error-messages="errorMessages('data.address_et')"
                                :class="{ 'error--text': hasErrors('data.address_et') }"
                                class="primary--text"
                                label="Et"
                                data-vv-as="Et"
                                data-vv-name="data.address_et"
                                name="data.address_et"
                            />
                        </v-col>
                        <v-col cols="1">
                            <v-text-field
                                v-model="form.data.address_ap"
                                :error-messages="errorMessages('data.address_ap')"
                                :class="{ 'error--text': hasErrors('data.address_ap') }"
                                class="primary--text"
                                label="Ap"
                                data-vv-as="Ap"
                                data-vv-name="data.address_ap"
                                name="data.address_ap"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.data.id_type"
                                v-validate="'required'"
                                :error-messages="errorMessages('data.id_type')"
                                :class="{ 'error--text': hasErrors('data.id_type') }"
                                class="primary--text"
                                name="data.id_type"
                                label="Tip act de identitate (CI/BI)"
                                data-vv-as="Tip act de identitate (CI/BI)"
                                data-vv-name="data.id_type"
                            />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                v-model="form.id_serial"
                                v-validate="'required'"
                                :error-messages="errorMessages('id_serial')"
                                :class="{ 'error--text': hasErrors('id_serial') }"
                                class="primary--text"
                                name="id_serial"
                                label="Serie CI"
                                data-vv-as="Serie CI"
                                data-vv-name="id_serial"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.id_no"
                                v-validate="'required'"
                                :error-messages="errorMessages('id_no')"
                                :class="{ 'error--text': hasErrors('id_no') }"
                                class="primary--text"
                                name="id_no"
                                label="Numar CI"
                                data-vv-as="Numar CI"
                                data-vv-name="id_no"
                                counter="6"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                v-model="form.id_pin"
                                v-validate="'required'"
                                :error-messages="errorMessages('id_pin')"
                                :class="{ 'error--text': hasErrors('id_pin') }"
                                class="primary--text"
                                name="id_pin"
                                label="CNP"
                                data-vv-as="CNP"
                                data-vv-name="id_pin"
                                counter="13"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                v-model="form.emitted_by"
                                v-validate="'required'"
                                :error-messages="errorMessages('emitted_by')"
                                :class="{ 'error--text': hasErrors('emitted_by') }"
                                class="primary--text"
                                name="emitted_by"
                                label="Emitent CI"
                                data-vv-as="Emitent CI"
                                data-vv-name="emitted_by"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-date-field
                                v-model="form.emitted_at"
                                v-validate="'required'"
                                :error-messages="errorMessages('emitted_at')"
                                :class="{ 'error--text': hasErrors('emitted_at') }"
                                class="primary--text"
                                name="emitted_at"
                                label="Data emiterii"
                                data-vv-as="Data emiterii"
                                data-vv-name="emitted_at"
                            ></v-date-field>
                        </v-col>
                    </v-row>

                    <v-divider
                        class="mx-4"
                        vertical
                    ></v-divider>
                    <v-subheader>
                        Alte informatii
                    </v-subheader>


                    <v-row>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.fathers_name"
                                :error-messages="errorMessages('data.fathers_name')"
                                :class="{ 'error--text': hasErrors('data.fathers_name') }"
                                class="primary--text"
                                name="data.fathers_name"
                                label="Nume tata"
                                data-vv-as="Nume tata"
                                data-vv-name="data.fathers_name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.mothers_name"
                                :error-messages="errorMessages('data.mothers_name')"
                                :class="{ 'error--text': hasErrors('data.mothers_name') }"
                                class="primary--text"
                                name="data.mothers_name"
                                label="Nume mama"
                                data-vv-as="Nume mama"
                                data-vv-name="data.mothers_name"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.citizenship"
                                :error-messages="errorMessages('data.citizenship')"
                                :class="{ 'error--text': hasErrors('data.citizenship') }"
                                class="primary--text"
                                name="data.citizenship"
                                label="Cetatenie"
                                data-vv-as="Cetatenie"
                                data-vv-name="data.citizenship"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-date-field
                                v-model="form.data.birthday"
                                :error-messages="errorMessages('data.birthday')"
                                :class="{ 'error--text': hasErrors('data.birthday') }"
                                class="primary--text"
                                name="data.birthday"
                                label="Data nasterii"
                                data-vv-as="Data nasterii"
                                data-vv-name="data.birthday"
                            ></v-date-field>
                        </v-col>

                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.birth_location_country"
                                :error-messages="errorMessages('data.birth_location_country')"
                                :class="{ 'error--text': hasErrors('data.birth_location_country') }"
                                class="primary--text"
                                name="data.birth_location_country"
                                label="Locul nasterii - tara"
                                data-vv-as="Locul nasterii - tara"
                                data-vv-name="data.birth_location_country"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.birth_location_county"
                                :error-messages="errorMessages('data.birth_location_county')"
                                :class="{ 'error--text': hasErrors('data.birth_location_county') }"
                                class="primary--text"
                                name="data.birth_location_county"
                                label="Locul nasterii - judet"
                                data-vv-as="Locul nasterii - judet"
                                data-vv-name="data.birth_location_county"
                                counter="255"
                            />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                v-model="form.data.birth_location_city"
                                :error-messages="errorMessages('data.birth_location_city')"
                                :class="{ 'error--text': hasErrors('data.birth_location_city') }"
                                class="primary--text"
                                name="data.birth_location_city"
                                label="Locul nasterii - localitate"
                                data-vv-as="Locul nasterii - localitate"
                                data-vv-name="data.birth_location_city"
                                counter="255"
                            />
                        </v-col>
                    </v-row>

                    <v-btn
                        :loading="form.busy"
                        :disabled="errors.any() || form.busy"
                        block
                        color="success"
                        @click="submit()"
                    >
                        Salveaza
                        <v-icon right>
                            save
                        </v-icon>
                    </v-btn>
                </v-card>
            </v-tab-item>

            <v-tab-item key="contracts">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="12">
                            <contracts v-if="form.id" :contracts="form.contracts" :customer-id="form.id" @refresh="loadResource"></contracts>
                            <v-alert v-else dense type="info">
                                Nu sunt contracte inregistrate pentru acest cursant.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>

            <v-tab-item key="payments">
                <v-card class="px-4 py-4" flat>
                    <v-row>
                        <v-col cols="12">
                            <payments v-if="form.id" :payments="form.payments" :accountables="accountables" :customer-id="form.id" @refresh="loadResource"></payments>
                            <v-alert v-else dense type="info">
                                Nu sunt plati inregistrate pentru acest cursant.
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";
    import Contracts from './Contracts'
    import Payments from './Payments'
    import debounce from 'lodash/debounce'

    export default {
        components: {
            Payments,
            Contracts
        },
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: false,
            foundCustomers: undefined,
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                workstation_id: null,
                name: null,
                surname: null,
                maiden_name: null,
                county_id: null,
                city: null,
                address: null,
                id_serial: null,
                id_no: null,
                id_pin: null,
                emitted_by: null,
                emitted_at: null,
                phone: null,
                contracts: [],
                payments: [],
                data: {
                    fathers_name: null,
                    mothers_name: null,
                    citizenship: null,
                    birthday: null,
                    sex: null,
                    birth_location_country: null,
                    birth_location_county: null,
                    birth_location_city: null,
                    id_type: null,
                    address_no: null,
                    address_bl: null,
                    address_sc: null,
                    address_et: null,
                    address_ap: null,
                    email: null
                }
            })
        }),
        watch: {
            'form.id_pin': {
                handler: debounce(function (val) {
                    this.foundCustomers = -1
                    this.$db.Customer
                        .select('name', 'surname')
                        .where('id_pin', val)
                        .get()
                        .then(({data}) => {
                            this.foundCustomers = data.length
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.foundCustomers = undefined
                            }, 10000)
                        })
                }, 500)
            }
        },
        computed: {
            accountables() {
                const contracts = [...this.Static.sharedContracts, ...this.form.contracts]
                return contracts.map((contract) => {
                    const text = contract.shared ?
                        contract.category :
                        `Contract cat ${contract.category} nr. ${this._.isNil(contract.contract_no) ? 'Nedefinit' : contract.contract_no} din data de ${this.$moment(contract.contract_date).format('DD/MM/YYYY')}`
                    let data = {}
                    if (contract.custom_invoice_data) {
                        data = {
                            company_address: this._.get(contract, 'data.company_address'),
                            company_name: this._.get(contract, 'data.company_name'),
                            company_rc: this._.get(contract, 'data.company_rc'),
                            company_vat: this._.get(contract, 'data.company_vat')
                        }
                    } else {
                        data = {
                            company_address: ` ${this.form.address || ''} ${this.form.data.address_no || ''} ${this.form.data.address_bl || ''} ${this.form.data.address_sc || ''} ${this.form.data.address_et || ''} ${this.form.data.address_ap || ''}, ${this.form.city}`,
                            company_name: `${this.form.name} ${this.form.surname}`,
                            company_rc: `${this.form.id_serial} ${this.form.id_no}`,
                            company_vat: `${this.form.id_pin}`
                        }
                    }
                    return {
                        accountable_id: contract.id,
                        accountable_type: 'App\\Models\\Contract',
                        text: text,
                        shared: contract.shared,
                        data: data
                    }
                })
            }
        },
        async mounted() {
            if(this.id) {
                await this.loadResource()
            }
        },
        methods: {
            async loadResource() {
                let self = this;
                this.loading = true;

                let { data } = await this.$db.Customer
                    .include(
                        'payments.transactions',
                        'payments.invoice',
                        'payments.createdBy',
                        'payments.updatedBy',
                        'contracts.theoryInstructor',
                        'contracts.drivingInstructor',
                        'contracts.createdBy',
                        'contracts.updatedBy',
                    )
                    .find(this.id)
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                var model = new this.$db.Customer(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "customers-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                        self.form.busy = false;
                    });
            }
        }
    };
</script>
